import { render, staticRenderFns } from "./DocumentEdit.vue?vue&type=template&id=f53c36fe&scoped=true"
import script from "./DocumentEdit.vue?vue&type=script&lang=js"
export * from "./DocumentEdit.vue?vue&type=script&lang=js"
import style0 from "./DocumentEdit.vue?vue&type=style&index=0&id=f53c36fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53c36fe",
  null
  
)

export default component.exports